/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { useSelector } from "react-redux";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import {
  canReadMarketing,
  isFullAdmin,
} from "../../../../../app/modules/Auth/access";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const user = useSelector(state => state.auth.user);
  const fullAdmin = isFullAdmin(user);
  const marketingEnabled = canReadMarketing(user);
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        {fullAdmin && (
          <li
            className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/dashboard">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
              </span>
              <span className="menu-text">Panel</span>
            </NavLink>
          </li>
        )}
        {/*end::1 Level*/}

        {marketingEnabled && (
          <li
            className={`menu-item ${getMenuItemActive("/marketing", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/marketing">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Chart-line2.svg")} />
              </span>
              <span className="menu-text">Marketing</span>
            </NavLink>
          </li>
        )}

        {fullAdmin && (
          <li
            className={`menu-item ${getMenuItemActive("/permissions", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/permissions">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/Lock.svg")} />
              </span>
              <span className="menu-text">Permisos</span>
            </NavLink>
          </li>
        )}

        {/* Components */}
        {/* begin::section */}
        {fullAdmin && (
          <li className="menu-section ">
            <h4 className="menu-text">Clientes</h4>
            <i className="menu-icon flaticon-more-v2"></i>
          </li>
        )}
        {/* end:: section */}

        {fullAdmin && (
          <li
            className={`menu-item ${getMenuItemActive("/users", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/users">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
              </span>
              <span className="menu-text">Usuarios</span>
            </NavLink>
          </li>
        )}

        {/* Components */}
        {/* begin::section 
        <li className="menu-section ">
          <h4 className="menu-text">Hardware</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>

        <li
          className={`menu-item ${getMenuItemActive("/hardware", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/hardware">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Electric/Air-conditioning.svg")} />
            </span>
            <span className="menu-text">Hardware</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive("/commands", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/commands">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Tools/Tools.svg")} />
            </span>
            <span className="menu-text">Comandos</span>
          </NavLink>
        </li>*/}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
